import Home from '../pages/Home'
import Solicitacao from '../pages/Solicitacao'
import Login from '../pages/Login'
import Dashboard from "../pages/Dashboard"
import AcompanhamentoComunicacoes from '../pages/AcompanhamentoComunicacoes'
import MinhasComunicacoes from '../pages/MinhasComunicacoes'
import Triagem from '../pages/Triagem'
import GerenciaPerfis from '../pages/GerenciaPerfis'

// eslint-disable-next-line import/no-anonymous-default-export
export default [
    { path: '/', name: 'Home', Component: Home, roles: ['uma_authorization'] },
    { path: '/Home/', name: 'Home', Component: Home, roles: ['uma_authorization'] },
    { path: '/Login/', name: 'Login', Component: Login, roles: ['uma_authorization'] },
    { path: '/Dashboard/', name: 'Minha Área', Component: Dashboard, roles: ['uma_authorization'] },
    { path: '/AcompanhamentoComunicacoes/', name: 'Comunicações', Component: AcompanhamentoComunicacoes, roles: ['TCOM-TCE-ADM', 'TCOM-TCE-COM'] },
    { path: '/MinhasComunicacoes/', name: 'Minhas Comunicações', Component: MinhasComunicacoes, roles: ['TCOM-JRSD-GST', 'TCOM-JRSD-GAC', 'TCOM-JRSD-OPA', 'TCOM-JRSD-OPL'] },    
    { path: '/Triagem/', name: 'Minhas Triagens', Component: Triagem, roles: ['TCOM-TCE-ADM', 'TCOM-TCE-TRI'] },
    { path: '/GerenciaPerfis/', name: 'Gerenciar Perfis', Component: GerenciaPerfis, roles: ['TCOM-JRSD-GST', 'TCOM-JRSD-GAC', 'TCOM-TCE-ADM'] },
    { path: '/Solicitacao/', name: 'Solicitação de Acesso do Gestor Jurisdicionado', Component: Solicitacao, roles: ['uma_authorization', 'TCOM-JRSD-GST'] },
]